import { h, Host } from '@stencil/core';
import { UniTemplate } from './template';
export const UniHostTemplate = function ({ props, classes }, template) {
  return h(Host, Object.assign({}, props, { class: classes }), UniTemplate(template));
};
